import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { Formik, FormikContextType } from 'formik';
import { SiteAnnouncementFormContent } from './SiteAnnouncementFormContent';
import { SiteAnnouncementFormData } from 'core/siteAnnouncement/SiteAnnouncement';
import { FormConfig } from 'components/common/form/FormConfig';
import { useCallback } from 'react';

export type SiteAnnouncementFormProps = {
  siteAnnouncement?: SiteAnnouncementFormData;
  goNext: (onGoNext?: () => void) => void;
  onCancel: () => void;
  validateForm: (
    values: SiteAnnouncementFormData
  ) => Record<string, string | undefined>;
  getFormConfig: (
    props: FormikContextType<SiteAnnouncementFormData>
  ) => FormConfig;
  setSiteAnnouncement: (siteAnnouncement: SiteAnnouncementFormData) => void;
};

export const SiteAnnouncementForm: React.FC<SiteAnnouncementFormProps> = ({
  siteAnnouncement,
  goNext,
  onCancel,
  validateForm,
  getFormConfig,
  setSiteAnnouncement
}) => {
  const onSubmit = useCallback(
    (values: SiteAnnouncementFormData) => {
      goNext(() => setSiteAnnouncement(values));
    },
    [goNext, setSiteAnnouncement]
  );

  if (!siteAnnouncement) {
    return <LoadingIndicator />;
  }

  return (
    <Formik
      initialValues={siteAnnouncement}
      onSubmit={onSubmit}
      validate={validateForm}
      validateOnBlur={false}
      enableReinitialize
    >
      <SiteAnnouncementFormContent
        formConfigGetter={getFormConfig}
        onCancel={onCancel}
      />
    </Formik>
  );
};
